import { graphql } from 'react-apollo'
import { Layout, Table } from 'antd'
import PropTypes from 'prop-types'
import React from 'react'

import Footer from '../components/Footer'
import Navbar from '../components/Navbar'
import usersScannedQuery from '../graphql/queries/usersScanned'

import '../css/table.css'

const { Content } = Layout

const Users = (props) => {
  const { users: { loading, users = [] } } = props
  const columns = [
    {
      title: 'Name',
      dataIndex: 'name',
      key: 'name',
    },
    {
      title: 'Scanned',
      children: [
        {
          title: 'Label',
          dataIndex: 'scannedLabelCount',
          key: 'scannedLabelCount',
          width: 200,
          className: 'text-right',
        },
        {
          title: 'CheckIn',
          dataIndex: 'checkInItemCount',
          key: 'checkInItemCount',
          width: 200,
          className: 'text-right',
        },
        {
          title: 'CheckOut',
          dataIndex: 'checkOutItemCount',
          key: 'checkOutItemCount',
          width: 200,
          className: 'text-right',
        },
      ],
    },
  ]
  return (
    <Layout>
      <Navbar selected="user:1" />
      <Content style={{ padding: '0 20px' }}>
        <div style={{ background: '#fff', padding: 24, minHeight: 'calc(100vh - 64px - 69px)' }}>
          <h2>Users</h2>
          <Table
            dataSource={users}
            columns={columns}
            rowKey="_id"
            pagination={{ pageSize: 50 }}
            size="middle"
            loading={loading}
            bordered
          />
        </div>
      </Content>
      <Footer />
    </Layout>
  )
}
Users.propTypes = {
  users: PropTypes.shape({
    error: PropTypes.object,
    loading: PropTypes.bool,
    users: PropTypes.array,
  }).isRequired,
}
Users.defaultProps = {}

export default graphql(usersScannedQuery, { name: 'users' })(Users)



// WEBPACK FOOTER //
// ./src/pages/Users.js